export default __webpack_public_path__ + "static/media/adtech_logo.0f633c14.png";